import { render } from "./PlansAndPrices.vue?vue&type=template&id=75d38386&ts=true"
import script from "./PlansAndPrices.vue?vue&type=script&lang=ts"
export * from "./PlansAndPrices.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__